import { render, staticRenderFns } from "./loadImgOssUp.vue?vue&type=template&id=48006a51"
import script from "./loadImgOssUp.vue?vue&type=script&lang=js"
export * from "./loadImgOssUp.vue?vue&type=script&lang=js"
import style0 from "./loadImgOssUp.vue?vue&type=style&index=0&id=48006a51&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48006a51')) {
      api.createRecord('48006a51', component.options)
    } else {
      api.reload('48006a51', component.options)
    }
    module.hot.accept("./loadImgOssUp.vue?vue&type=template&id=48006a51", function () {
      api.rerender('48006a51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/loadImgOssUp.vue"
export default component.exports